import { FC } from 'react';
import Button from '@ingka/button';
import TrashIcon from '@ingka/ssr-icon/paths/trash-can';

export const PillComboWrapper: FC<{
  children: React.ReactNode;
}> = ({ children }) => <div className="flex flex-wrap gap-2">{children}</div>;

export const PillComboItem: FC<{
  title: string;
  onRemove?: () => void;
}> = ({ title, onRemove }) => (
  <div className="flex bg-skapa-interactive-secondary-bg-default rounded-full px-4 py-1 items-center">
    <div>{title}</div>
    {onRemove && (
      <Button
        className="ml-2"
        title="Remove"
        type="tertiary"
        size="xsmall"
        iconOnly
        ssrIcon={TrashIcon}
        onClick={onRemove}
      />
    )}
  </div>
);
